import pkg from '../../package.json';

export const env = {
  version: `v${pkg.version}`,
};
